import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BlogPostCard from "@/components/BlogPostCard";
import { blogPosts } from "@/utils/blogData";
import Seo from "@/components/Seo";

const Blog = () => {
  return (
    <div className="min-h-screen bg-[#f1f1f1] flex flex-col">
      <Seo
        title="Blog – Trading Card Selling, Photography & Grading Guides"
        description="In-depth guides on photographing, grading, valuing, and listing trading cards online. Practical tips from CardCombiner for sellers and collectors."
        path="/blog"
      />
      <Navbar />
      <div className="max-w-4xl mx-auto p-4 md:p-8 flex-grow">
        <div className="bg-white p-6 md:p-8 rounded-[16px] md:rounded-[24px] shadow-lg">
          <h1 className="text-3xl md:text-4xl font-bold mb-8 text-[#6B4EE6]">Blog</h1>
          
          <div className="space-y-6">
            {blogPosts.map((post) => (
              <BlogPostCard
                key={post.id}
                title={post.title}
                slug={post.slug}
                date={post.date}
                author={post.author}
                excerpt={post.excerpt}
                 image={post.image}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blog;
